import { render, staticRenderFns } from "./StartForm3.vue?vue&type=template&id=07d0a00d&scoped=true"
import script from "./StartForm3.vue?vue&type=script&lang=ts"
export * from "./StartForm3.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d0a00d",
  null
  
)

export default component.exports